<template>
<div>
  <h6>
    Your Registered Card Details
  </h6>
  <div v-for="card of creditCards">
    <i :class="'fab fa-4x fa-cc-'+card.cardType.toLowerCase()" class="white--text"></i>
  </div>
</div>
</template>

<script>
export default {
name: "CardDetails",
  props: {
    creditCards: Array
  }
}
</script>

<style scoped>

</style>
